import Vue from "vue";
import Vuex from "vuex";
import config from "./modules/config";
import menu from "./modules/schoolMenu";
import select from "./modules/schoolSelect";

import createPersistedState from "vuex-persistedstate";
const vueObject = new Vue({});
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  state: {
    indexShowNumber: sessionStorage.getItem("indexShowNumber") || 0,

    // 学校大数据版本
    schoolBidDataVersion: 1,
    // 教育局大数据版本
    eduBidDataVersion: 1,


    // 教育局大数据选中title
    eduBidDataSelect: 1,

    // 是否选择安全资料开头
    isSafeInfo: true,

    // 学校ID
    schoolId: sessionStorage.getItem("schoolId") || "",
    // 登录后获取学校信息
    schoolInfo: {},

    // 选中食堂id
    diningRoomId: 0,

    // 学校信息
    schoolData: sessionStorage.getItem("schoolInfo")
      ? sessionStorage.getItem("schoolInfo")
      : false,

    // 用户信息
    userInfo: sessionStorage.getItem("userInfo")
      ? sessionStorage.getItem("userInfo")
      : false,

    // 教育局信息
    eduInfo: sessionStorage.getItem("eduInfo")
      ? sessionStorage.getItem("eduInfo")
      : false,
    eduIdResize: 0,
    eduIdResizeInfo: {},
    schoolIdResize: 0,
    schoolIdResizeInfo: {},
    schoolAndEduList: [],

    // 安全中心（选中教育局信息）
    eduSelectInfo: {},

    // 安全中心（教育局下学校列表信息）
    eduSchoolInfo: {},

    // 安全中心（选中学校信息）
    eduSelectSchool: {},

    // 安全中心（选中视频信息）
    eduSelectVideo: {},

    // 监控中心截图触发
    captureResize: 0,

    // 广播区域id
    broadcastId: "",

    // 控制器id
    broadcastConrId: "",

    // 作息表选中广播资源
    selectBroadcastCatalogIdTemp: "",
    selectBroadcastNameTemp: "",
    selectBroadcastCatalogId: "",
    selectBroadcastName: "",

    // 校园安全大数据隐患实时状态选中id
    hiddenDangerId: "",
    hiddenDangerIdResize: "",

    // 校园安全大数据食品安全选中食堂id
    selectCanteenId: "",

    // 选中左侧菜单索引
    menuListKeyOne: "",
    menuListKeyTwo: "",

    // 高校安全中心（选中学院/食堂信息）
    universitySelectCollege: {},
    // 高校安全中心（选中监控信息）
    universitySelectVideo: {},

    // 后勤总公司查看隐患选择院系id
    collegeId: "",

    hiddenDangerDataNumber:0, //数值变化时刷新列表

    pathIndex:'0-0',
    pathArr:[],
    messagesNumber:0, // 学校未读消息
    messagesNumberEdu:0, // 教育局未读消息
    hiddenDangerType: []  // 全部隐患类型

  },

  getters: {
    getUserInfo: (state) => JSON.parse(state.userInfo),
    getSchoolData: (state) => JSON.parse(state.schoolData),
    getEduData: (state) => JSON.parse(state.eduInfo)
  },
  mutations: {
    // 学校大数据版本
    setSchoolBidDataVersion(state, value) {
      state.schoolBidDataVersion = value;
    },
    // 教育局大数据版本
    setEduBidDataVersion(state, value) {
      state.eduBidDataVersion = value;
    },

    setEduBidDataSelect(state, value) {
      state.eduBidDataSelect = value;
    },

    //是否选择资料
    setSelect(state, setDataValue) {
      state.isSafeInfo = setDataValue;
    },
    updateSchoolId(state, value) {
      state.schoolId = value;
    },

    updateSchoolInfo(state, value) {
      state.schoolInfo = value;
    },
    // 更新选中食堂id
    updateDiningRoomId(state, value) {
      state.diningRoomId = value;
    },

    updateUserInfo(state, value) {
      state.userInfo = value;
    },

    schoolAndEduList(state, value) {
      state.schoolAndEduList = value;
    },

    updateEduInfo(state, value) {
      state.eduInfo = value;
    },
    // 更新安全中心（学校信息）
    updateEduSelectInfo(state, value) {
      state.eduSelectInfo = value;
    },
    // 更新安全中心（学校信息）
    updateEduSchoolInfo(state, value) {
      state.eduSchoolInfo = value;
    },
    // 更新安全中心（选中学校信息）
    updateEduSelectSchool(state, value) {
      state.eduSelectSchool = value;
    },
    // 更新安全中心（选中视频信息）
    updateEduSelectVideo(state, value) {
      state.eduSelectVideo = value;
    },

    setDataValue(state, actionObject) {
      // console.log(actionObject);
      state[actionObject.actionObjectName] = actionObject.actionObjectValue;
    },
    // 根据值来判断是否更新教育局数据
    updateEduIdResize(state, value) {
      state.eduIdResize = value;
    },
    // 根据值来查询教育局信息
    updateEduIdResizeInfo(state, value) {
      state.eduIdResizeInfo = value;
    },
    // 根据值来判断是否更新教育局数据
    updateSchoolIdResize(state, value) {
      state.schoolIdResize = value;
    },
    // 根据值来查询教育局信息
    updateSchoolIdResizeInfo(state, value) {
      state.schoolIdResizeInfo = value;
    },

    // 更新截图操作（触发弹窗）
    updateCaptureResize(state, value) {
      state.captureResize = value;
    },

    // 更新广播id
    updateBroadcastId(state, value) {
      state.broadcastId = value;
    },

    // 更新广播id
    updateBroadcastConrId(state, value) {
      state.broadcastConrId = value;
    },

    // 更新选中广播id
    updateSelectBroadcastCatalogIdTemp(state, value) {
      state.selectBroadcastCatalogIdTemp = value;
    },
    updateSelectBroadcastNameTemp(state, value) {
      state.selectBroadcastNameTemp = value;
    },
    updateSelectBroadcastCatalogId(state, value) {
      state.selectBroadcastCatalogId = value;
    },
    updateSelectBroadcastName(state, value) {
      state.selectBroadcastName = value;
    },

    // 更新校园安全大数据隐患实时状态选中id
    updateHiddenDangerId(state, value) {
      state.hiddenDangerId = value;
    },
    // 更新校园安全大数据隐患实时状态选中id 触发条件
    updateHiddenDangerIdResize(state, value) {
      state.hiddenDangerIdResize = value;
    },

    // 更新校园安全大数据食品安全选中食堂id
    updateSelectCanteenId(state, value) {
      state.selectCanteenId = value;
    },

    // 更新选中左侧菜单索引
    updateMenuListKeyOne(state, value) {
      state.menuListKeyOne = value;
    },
    updateMenuListKeyTwo(state, value) {
    },

    // 更新高校安全中心（选中学院/食堂信息）
    updateUniversitySelectCollege(state, value) {
      state.universitySelectCollege = value;
    },
    // 更新高校安全中心（选中监控信息）
    updateUniversitySelectVideo(state, value) {
      state.universitySelectVideo = value;
    },

    // 后勤总公司查看隐患选择院系id
    updateCollegeId(state, value) {
      state.collegeId = value;
    },

    // 刷新隐患数据列表
    updateHiddenDangerDataNumber(state, value) {
      state.hiddenDangerDataNumber = value;
    },

    // 刷新页面时使用
    updatePathIndex(state, value) {
      state.pathIndex = value;
    },
    // 刷新页面时使用
    updatePathArr(state, value) {
      state.pathArr = value;
    },

    // 未读消息个数(学校)
    unreadMessages(state, value) {
      state.messagesNumber = value;
    },

    // 未读消息个数(教育局)
    unreadMessagesEdu(state, value) {
      state.messagesNumberEdu = value;
    },
    
    // 更新全部隐患类型
    updateHiddenDangerType(state, value) {
      state.hiddenDangerType = value;
    },
  
  },
  actions: {},
  modules: {
    config,
    menu,
    select
  }
});
